/**
 * @file
 * Section Menu Panel — breadcrumb-bar drop-down.
 */

(function (Drupal, once) {
  "use strict";

  var PANEL_ID = "section-menu-panel";

  Drupal.behaviors.sectionMenuPanel = {
    attach: function (context) {
      var panel = document.getElementById(PANEL_ID);
      if (!panel) {
        return;
      }

      once("sectionMenuPanelTrigger", ".section-menu-panel__trigger", context).forEach(
        function (button) {
          button.addEventListener("click", function () {
            var isOpen = button.getAttribute("aria-expanded") === "true";
            setOpen(!isOpen, button, panel);
          });
        },
      );

      once("sectionMenuPanelKeys", "body", context).forEach(function (body) {
        body.addEventListener("keydown", function (e) {
          if (e.key !== "Escape") return;
          var trigger = document.querySelector(
            '.section-menu-panel__trigger[aria-expanded="true"]',
          );
          if (trigger) {
            setOpen(false, trigger, panel);
            trigger.focus();
          }
        });

        window.addEventListener("resize", function () {
          if (!panel.hasAttribute("hidden")) {
            fitColumns(panel);
          }
        });

        body.addEventListener("click", function (e) {
          var trigger = document.querySelector(
            '.section-menu-panel__trigger[aria-expanded="true"]',
          );
          if (!trigger) return;
          if (trigger.contains(e.target) || panel.contains(e.target)) return;
          setOpen(false, trigger, panel);
        });
      });
    },
  };

  function setOpen(open, trigger, panel) {
    trigger.setAttribute("aria-expanded", open ? "true" : "false");
    if (open) {
      panel.removeAttribute("hidden");
    } else {
      panel.setAttribute("hidden", "");
    }
    document.body.classList.toggle("section-menu-is-open", open);
    if (open) {
      fitColumns(panel);
    }
  }

  // Links and height per column; only a column-wide gap starts a new one.
  function columnStats(list) {
    var els = list.querySelectorAll(
      ".section-menu-panel__group-title, .section-menu-panel__item",
    );
    var boxes = [];
    for (var i = 0; i < els.length; i++) {
      var link = els[i].querySelector(":scope > a");
      if (link) {
        boxes.push(link.getBoundingClientRect());
      }
    }
    boxes.sort(function (a, b) {
      return a.left - b.left;
    });

    var columns = [];
    for (var j = 0; j < boxes.length; j++) {
      var box = boxes[j];
      var column = columns[columns.length - 1];
      if (!column || box.left - column.left > 150) {
        columns.push({
          left: box.left,
          links: 1,
          top: box.top,
          bottom: box.bottom,
        });
      } else {
        column.links++;
        column.top = Math.min(column.top, box.top);
        column.bottom = Math.max(column.bottom, box.bottom);
      }
    }
    return columns;
  }

  // Heights, not link counts: a short column can still hold several links.
  function columnsLookRight(list, wanted) {
    var columns = columnStats(list);
    if (columns.length < wanted) {
      return false;
    }
    var shortest = Infinity;
    var tallest = 0;
    for (var i = 0; i < columns.length; i++) {
      if (columns[i].links < 2) {
        return false;
      }
      var height = columns[i].bottom - columns[i].top;
      shortest = Math.min(shortest, height);
      tallest = Math.max(tallest, height);
    }
    return shortest >= tallest * 0.3;
  }

  var MIN_WHOLE = 120;

  // Measured whole: a split branch reports only its fragments.
  function measureBranches(list) {
    var branches = list.querySelectorAll(
      ".section-menu-panel__group, .section-menu-panel__item--parent",
    );
    var i;
    for (i = 0; i < branches.length; i++) {
      branches[i].classList.add("is-whole");
    }
    var measured = { branches: branches, heights: [], total: 0 };
    for (i = 0; i < branches.length; i++) {
      measured.heights[i] = branches[i].getBoundingClientRect().height;
      if (
        !branches[i].parentNode.closest(
          ".section-menu-panel__group, .section-menu-panel__item--parent",
        )
      ) {
        measured.total += measured.heights[i];
      }
    }
    return measured;
  }

  function pinBranches(measured, budget) {
    for (var i = 0; i < measured.branches.length; i++) {
      var links = measured.branches[i].querySelectorAll("a").length;
      measured.branches[i].classList.toggle(
        "is-whole",
        links > 1 && measured.heights[i] <= budget,
      );
    }
  }

  // Step down until the columns look right, retrying with less held together.
  function fitColumns(panel) {
    var list = panel.querySelector(".section-menu-panel__list");
    if (!list) {
      return;
    }
    list.style.columnCount = "";
    var max = parseInt(window.getComputedStyle(list).columnCount, 10);
    if (!max || max < 2) {
      pinBranches(measureBranches(list), MIN_WHOLE);
      return;
    }

    for (var n = max; n > 1; n--) {
      list.style.columnCount = n;
      var measured = measureBranches(list);
      // An even split's column height; the browser's own is skewed by tall branches.
      var budgets = [Math.max((measured.total / n) * 1.1, MIN_WHOLE), MIN_WHOLE];
      for (var b = 0; b < budgets.length; b++) {
        pinBranches(measured, budgets[b]);
        if (columnsLookRight(list, n)) {
          return;
        }
      }
    }

    list.style.columnCount = 1;
    pinBranches(measureBranches(list), MIN_WHOLE);
  }
})(Drupal, once);
